import { render, staticRenderFns } from "./MoreItemsMobile.vue?vue&type=template&id=089cfe41&scoped=true&"
import script from "./MoreItemsMobile.vue?vue&type=script&lang=js&"
export * from "./MoreItemsMobile.vue?vue&type=script&lang=js&"
import style0 from "./MoreItemsMobile.vue?vue&type=style&index=0&id=089cfe41&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089cfe41",
  null
  
)

export default component.exports